export enum SubscriberEngagementRecapStatsType {
    CertificationCount = 'certificationCount',
    CoursesCompletedCount = 'coursesCompletedCount',
    CoursesEnrolledCount = 'coursesEnrolledCount',
    LearningDaysCount = 'learningDaysCount',
    LongestWeeklyStreak = 'longestWeeklyStreak',
    MinutesWatched = 'minutesWatched',
    TopicsExplored = 'topicsExplored',
}

export type SubscriberEngagementRecapStats = {
    [K in SubscriberEngagementRecapStatsType]?: K extends SubscriberEngagementRecapStatsType.TopicsExplored
        ? string[]
        : number;
};
